import { toast as sonnerToast } from "sonner";

// Wrapper to handle both old Radix UI format and Sonner format
const createToastWrapper = (options?: {
  position?: "top-center" | "bottom-right";
}) => {
  const wrappedToast = ((input: any, toastOptions?: any) => {
    // Handle object format: toast({ title, description, variant })
    if (typeof input === "object" && !Array.isArray(input)) {
      const { title, description, variant } = input;
      const message = title || description || "";
      const mergedOptions = { ...options, ...toastOptions };

      if (variant === "destructive") {
        return sonnerToast.error(title || message, {
          description: description,
          ...mergedOptions,
        });
      } else if (variant === "success") {
        return sonnerToast.success(title || message, {
          description: description,
          ...mergedOptions,
        });
      } else {
        // Default/warning
        return sonnerToast(title || message, {
          description: description,
          ...mergedOptions,
        });
      }
    }

    // Handle string format: toast("message") or toast("message", options)
    return sonnerToast(input, { ...options, ...toastOptions });
  }) as any;

  // Add Sonner methods
  wrappedToast.success = (input: string, opts?: any) =>
    sonnerToast.success(input, { ...options, ...opts });
  wrappedToast.error = (input: string, opts?: any) =>
    sonnerToast.error(input, { ...options, ...opts });
  wrappedToast.loading = (input: string, opts?: any) =>
    sonnerToast.loading(input, { ...options, ...opts });
  wrappedToast.dismiss = sonnerToast.dismiss;

  return wrappedToast;
};

export const toast = createToastWrapper();
export const toastVoucher = createToastWrapper({ position: "top-center" });

// Simple hook wrapper for compatibility
export const useToast = () => {
  return {
    toast,
    dismiss: (toastId?: string) => {
      if (toastId) {
        sonnerToast.dismiss(toastId);
      } else {
        sonnerToast.dismiss();
      }
    },
  };
};

// Hook for voucher/invitation code toasts
export const useVoucherToast = () => {
  return {
    toast: toastVoucher,
    dismiss: (toastId?: string) => {
      if (toastId) {
        sonnerToast.dismiss(toastId);
      } else {
        sonnerToast.dismiss();
      }
    },
  };
};

// Type for toast props (simplified - Sonner is flexible)
export type ToasterToast = {
  id?: string;
  title?: string;
  description?: string;
  variant?: "default" | "destructive" | "success";
};
